module.exports = __webpack_public_path__ + "eece85689def2c58606fb139114759b7.jpeg";